import InfoText from "@/components/InfoText";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface AssessmentDateCardProps {
  startDate?: string | null;
  endDate?: string | null;
}

function AssessmentDateCard({ startDate, endDate }: AssessmentDateCardProps) {
  const { t } = useTranslation();
  return (
    <div className="flex w-[320px] flex-col gap-6 self-baseline rounded-xl border bg-white px-5 py-4 shadow">
      {startDate && endDate ? (
        <InfoText
          label={t("assessment-date")}
          text={`${format(startDate, t("date-format"))} ~ ${format(endDate, t("date-format"))}`}
        />
      ) : (
        <InfoText label={t("not-active")} text={t("no-active-version")} />
      )}
    </div>
  );
}

export default AssessmentDateCard;
